import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

const NO_VALUE = '-';

const FunnelBar = ({ percent = null, variant = 'primary', label }) => {
    if (!Number.isFinite(percent)) return <span className="text-muted">{NO_VALUE}</span>;

    return (
        <div className="d-flex align-items-center gap-2" style={{ minWidth: '110px' }}>
            <ProgressBar
                now={Math.min(percent, 100)}
                variant={variant}
                className="flex-grow-1"
                style={{ height: '8px' }}
                aria-label={label}
            />
            <span className="small text-nowrap" style={{ minWidth: '3.25rem', textAlign: 'right' }}>{percent}%</span>
        </div>
    );
};

FunnelBar.propTypes = {
    percent: PropTypes.number,
    variant: PropTypes.string,
    label: PropTypes.string.isRequired
};

export default FunnelBar;
